import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=d1f94548&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=d1f94548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f94548",
  null
  
)

export default component.exports